import lockScroll from '../__utils/lockScroll';

const dropdownTrigger = document.querySelector('.hero-home__destination-dropdown');
const dropdownWrapper = document.querySelector('.hero-home__destination');

const localeHero = {
    activeClass: 'active'
};

const CLOSEHERO = 0;
const OPENHERO = 1;
let dropdownState = CLOSEHERO;

/**
 * Open hero dropdown.
 */
const openHero = () => {
    dropdownWrapper.classList.add(localeHero.activeClass);
    dropdownState = OPENHERO;
}

/**
 * Close hero dropdown.
 */
const closeHero = () => {
    dropdownWrapper.classList.remove(localeHero.activeClass);
    dropdownState = CLOSEHERO;
}

/**
 * Logic for toggle hero dropdown.
 */
const toggleHero = () => {
    dropdownState === CLOSEHERO ? openHero() : closeHero();
}

/**
 * Initial actions. Add event listener.
 */
const dropdownHeroInitial = () => {
    if (!dropdownWrapper) return;
    dropdownTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        toggleHero();
    });
}

/**
 * Hide hero dropdown on outside click.
 */
export const closeHeroDropdown = ({target}) => {
    if (dropdownWrapper && !(target === dropdownWrapper || dropdownWrapper.contains(target)) ) {
        closeHero();
    }
}

export default dropdownHeroInitial;
